import API_URLS from "@constants/apiUrls";
import { api } from "services/customBaseQuery";
import jsonToFormData from "@utils/jsonToFormData";

export const corporateSelectAPI = api.injectEndpoints({
  endpoints: (build) => ({
    fetchCorporateList: build.query<any, any>({
      query: (params) => {
        const queryString = params
          ? `?${new URLSearchParams(params).toString()}`
          : "";
        return {
          url: `${API_URLS.CORPORATE_LIST}${queryString}`,
          method: "GET",
          credentials: "include",
        };
      },
    }),
    selectCorporate: build.mutation<any, any>({
      query: (data) => {
        const body = jsonToFormData(data);
        return {
          url: API_URLS.SELECT_CORPORATE,
          method: "POST",
          body,
          credentials: "include",
        };
      },
      invalidatesTags: ["Promotions"],
    }),
  }),
});

export const { useFetchCorporateListQuery, useSelectCorporateMutation } =
  corporateSelectAPI;
